/**
 * 온보딩 체크리스트 항목을 즉시 완료 처리하는 모듈 레벨 헬퍼.
 *
 * `useOnboardingState` 의 `markCompleted` 와 동일한 localStorage 키 규약을 사용하지만
 * 훅 호출 없이 임의의 비동기 콜백(API 성공 핸들러 등)에서 호출 가능.
 *
 * 키 규약: `dokocrew_onboard_{userNo}_{stepKey}` = 'completed'
 * 사용 stepKey: `step_create`, `step_invite`, `step_schedule`, `step_cost`
 *
 * 동기: 데이터 기반 검사(memberCount > 1, proposalVoteCount > 0 등)는 invitee/peer 의
 * 응답에 의존하므로 inviter 행위만으로는 ✓ 가 안 켜진다. 사용자가 실제 액션
 * (초대 푸시, 제안 등록, 투표) 을 한 시점에 직접 마킹해 즉시 반영.
 */
export const markOnboardingCompleted = (stepKey: string): void => {
    try {
        const userNo = sessionStorage.getItem('userNo');
        if (!userNo) return;
        localStorage.setItem(`dokocrew_onboard_${userNo}_${stepKey}`, 'completed');
    } catch { /* storage 실패 — 다음 데이터 기반 검사가 다시 시도하므로 무시 */ }
};
